import * as React from 'react';

import { PropertyBookByPhone } from '@shared-ui/lodging-property-details';

import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './shared-ui-property-details';

const BookByPhoneWrapper: React.FC<SharedUiWrapperProps> = ({ inputs, className }) => (
  <PropertyBookByPhone inputs={inputs} className={className} />
);

export const SharedUiBookByPhoneWrapper = withSharedUiPropertyDetails<SharedUiWrapperProps>(BookByPhoneWrapper);
SharedUiBookByPhoneWrapper.displayName = 'SharedUiBookByPhoneWrapper';
